import PagingSetting from './PagingSetting'

export default PagingSetting
